import React, { useState, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Typography, Grid, Divider, Accordion, AccordionDetails, AccordionSummary, Box } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import HistoryItem from "./HistoryItem"
import HistoryDialog from "./HistoryDialog"
import HistoryCalculation from "./HistoryCalculation"
import { F_TRADING_CHAT } from "../../../constants/routes"
import BackdropContext from "../../../context/BackdropContext"
import StateContext from "../../../context/StateContext"

const History = ({ isMobile }) => {
  const navigate = useNavigate()

  const goToChat = () => navigate(F_TRADING_CHAT)

  const { backdropOpen, openBackdrop, closeBackdrop } = useContext(BackdropContext)

  const [currentBook, setCurrentBook] = useState(null)

  const { ledgerList, ledgerLoading } = useContext(StateContext)
  const finishedLedgers = !ledgerList || ledgerLoading ? [] : ledgerList.filter((b) => b.status === "finished")
  const boughtBooks = finishedLedgers.filter((b) => b.action === "buy")
  const soldBooks = finishedLedgers.filter((b) => b.action === "sell")

  const loading = ledgerLoading

  useEffect(() => {
    if (loading) {
      openBackdrop()
    } else {
      if (backdropOpen) {
        closeBackdrop()
      }
    }
  }, [loading, openBackdrop, backdropOpen, closeBackdrop])

  return (
    <>
      <Typography
        variant="h5"
        align={isMobile ? "center" : "left"}
        sx={{ color: "secondary.main", width: isMobile ? "96vw" : "auto", mb: isMobile ? 4 : 0, ml: "1vw", pt: "1vw" }}>
        Verlauf
      </Typography>

      <Box sx={{ width: "calc(100% - 2vw)", mx: "1vw", mt: "5vh" }}>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Auswertung</Typography>
            {/* <Tooltip
              title="Ergebnisse können abweichen, wenn von der Schule kein Originalpreis angegeben wurde. Bücherpakete werden nicht berücksichtigt."
              arrow
              placement="right">
              <HelpSharpIcon sx={{ color: "grey", ml: 1 }} />
            </Tooltip> */}
          </AccordionSummary>
          <AccordionDetails>
            <HistoryCalculation boughtBooks={boughtBooks} soldBooks={soldBooks} isMobile={isMobile} />
          </AccordionDetails>
        </Accordion>
      </Box>

      <Grid container justifyContent="space-evenly" sx={{ mt: isMobile ? 5 : "5vh" }}>
        <Grid item xs={5.9}>
          <Typography variant="subtitle1" align="center">
            Gekauft
          </Typography>
          {boughtBooks.map((p) => (
            <HistoryItem isMobile={isMobile} setCurrentBook={setCurrentBook} key={p.id} details={p} />
          ))}
        </Grid>
        <Grid item xs={0.2}>
          <Divider orientation="vertical" sx={{ width: isMobile ? "auto" : "70%" }} />
        </Grid>
        <Grid item xs={5.9}>
          <Typography variant="subtitle1" align="center">
            Verkauft
          </Typography>
          {soldBooks.map((p) => (
            <HistoryItem isMobile={isMobile} setCurrentBook={setCurrentBook} key={p.id} details={p} />
          ))}
        </Grid>
      </Grid>

      {currentBook && (
        <HistoryDialog
          goToChat={goToChat}
          details={currentBook}
          handleClose={() => {
            setCurrentBook(null)
          }}
        />
      )}
    </>
  )
}

export default History
